/**
 * Footer contact information
 */
export const contactInfo = {
  phones: [
    { number: "01204501468", display: "01204501468" },
    { number: "08065211468", display: "08065211468" },
  ],
  email: {
    address: "corvell@acrossassist.com",
    display: "corvell@acrossassist.com",
  },
};
